import {Component, OnDestroy, OnInit} from '@angular/core';

import {RegistryService} from "../../../../services/registry.service";
import {AuthService} from "../../../../../../services/auth.service";
import {PaymentService} from "../../../../services/payment.service";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-bank-transfer',
    templateUrl: './bank-transfer.component.html',
    styleUrls: ['./bank-transfer.component.css']
})
export class BankTransferComponent implements OnInit, OnDestroy {

    userLoggedOutEvent;
    orderId = null;

    methodSettings = null

    constructor(public registry: RegistryService,
                private authService: AuthService,
                private paymentService: PaymentService,
                private route:ActivatedRoute
    ) {

    }

    ngOnInit(): void {


        this.route.paramMap.subscribe( paramMap => {
            this.orderId = paramMap.get('orderid');

            this.paymentService.loadBankPaymentRestrictions().subscribe(result =>{
                this.methodSettings = result;
            });


        })



    }

    ngOnDestroy(): void {
    }

}
